var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgBox = function SvgBox(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.99 27.8c-.73-.09-1.52 0-2.25 0H19.72c-.7 0-1.83-.19-2.45.24-1.05.72-.77 2.64-.77 3.76v12.74c0 1.11-.21 2.58.23 3.63.48 1.19 1.54 1.03 2.57 1.03h18.22c2.78 0 5.69.25 8.46 0 .81-.07 1.25-.6 1.44-1.32.08-.21.12-.47.13-.68.01-.17.02-.35 0-.53V31.18c0-1.28.12-3.18-1.56-3.38Zm-6.81 8.19c-.52.22-1.44.06-1.98.06H25.76c-.16 0-.32.01-.48 0-1.06-.05-1-1.07-1-1.91 0-.26.03-1.05.4-1.18.53-.32 1.75-.11 2.31-.11h4.6c2.3 0 4.6-.03 6.9 0 .48 0 .84.03 1.05.54.23.61.33 2.29-.36 2.6ZM48.55 22.7c0-1.77.03-3.55 0-5.32-.02-1.18-.32-2.43-1.69-2.53-.73-.05-1.49 0-2.23 0h-26.7c-1.13 0-2.04.14-2.33 1.42-.06.19-.09.4-.1.58-.01.15-.02.32-.01.49-.02 2.63-.26 4.39.03 7 .14 1.28.87 1.87 2.05 1.87h28.46c.71 0 1.43.11 1.98-.46.86-.9.55-1.89.55-3.04Z"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBox);
export default ForwardRef;